<template>
  <div class="wishlist-container">
    <div class="container pt-3">
      <div class="row">
        <div class="col-12">
          <h1>Your Wishlist</h1>
        </div>
      </div>
    </div>
    <div class="duty-bar">
      <b-row>
        <b-col>
          <b-button-group>
            <b-button
              @click="
                duty_type = 'DP';
                dispatchDutyChangeEvent('DP');
              "
              :class="{ selected: duty_type === 'DP' }"
              >Retail</b-button
            >
            <b-button
              @click="
                duty_type = 'IB';
                dispatchDutyChangeEvent('IB');
              "
              :class="{ selected: duty_type === 'IB' }"
              >In Bond</b-button
            >
          </b-button-group>
        </b-col>
      </b-row>
    </div>
    <div class="wishlist-inner-container">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4 offset-md-4 my-2">
            <b-input-group>
              <b-form-input
                size="sm"
                v-model="search_term"
                placeholder="Search..."
              ></b-form-input>
            </b-input-group>
          </div>
        </div>
        <div class="row" v-if="search_term.length > 0">
          <div class="col-12">
            Searching for "<strong>{{ search_term }}</strong
            >"
          </div>
        </div>
        <div class="row" v-if="loading">
          <div class="col-12 text-center">
            <h6>Loading your wishlist...</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div
              class="wishlist-dp"
              v-if="duty_type === 'DP' && loading == false"
            >
              <div
                class="no-results text-center"
                v-if="Object.keys(dp_items).length === 0"
              >
                <h6 v-if="search_term.length > 0">
                  There are no items in your retail wishlist matching "{{
                    search_term
                  }}"
                </h6>
                <h6 v-else>There are no items in your retail wishlist</h6>
              </div>
              <search-result
                v-for="(item, index) in dp_items"
                :key="index"
                :result="item"
              ></search-result>
            </div>
            <div
              class="wishlist_ib"
              v-if="duty_type === 'IB' && loading == false"
            >
              <div
                class="no-results text-center"
                v-if="Object.keys(ib_items).length === 0"
              >
                <h6 v-if="search_term.length > 0">
                  There are no items in your in bond wishlist matching "{{
                    search_term
                  }}"
                </h6>
                <h6 v-else>There are no items in your in bond wishlist</h6>
              </div>
              <search-result-compact
                v-for="(item, index) in ib_items"
                :key="index"
                :result="item"
              ></search-result-compact>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global jQuery */

import SearchResult from "@/components/SearchResult.vue";
import SearchResultCompact from "@/components/SearchResultCompact.vue";
import jbs_api from "@/modules/jbs-api";
import { pickBy } from "lodash-es";

export default {
  components: {
    SearchResult,
    SearchResultCompact,
  },
  data() {
    return {
      items: [],
      loading: false,
      duty_type: "DP",
      search_term: "",
    };
  },
  computed: {
    dp_items() {
      return pickBy(this.items, (o) => {
        return o._source.DutyType === "DP" && this.itemMatchesSearchTerm(o);
      });
    },
    ib_items() {
      return pickBy(this.items, (o) => {
        return o._source.DutyType === "IB" && this.itemMatchesSearchTerm(o);
      });
    },
  },
  methods: {
    itemMatchesSearchTerm(item) {
      if (this.search_term.length === 0) return true;

      return (
        item._source.ItemDescription[0]
          .toLowerCase()
          .indexOf(this.search_term.toLowerCase()) !== -1 ||
        item._source.Colour[0]
          .toLowerCase()
          .indexOf(this.search_term.toLowerCase()) !== -1 ||
        item._source.Region[0]
          .toLowerCase()
          .indexOf(this.search_term.toLowerCase()) !== -1 ||
        item._source.BottleSize.toLowerCase().indexOf(
          this.search_term.toLowerCase()
        ) !== -1 ||
        item._source.Type.toLowerCase().indexOf(
          this.search_term.toLowerCase()
        ) !== -1 ||
        item._source.Country[0]
          .toLowerCase()
          .indexOf(this.search_term.toLowerCase()) !== -1
      );
    },
    dispatchDutyChangeEvent(duty) {
      if (typeof jQuery !== "undefined") {
        jQuery("body")
          .removeClass("current-duty-ib")
          .removeClass("current-duty-dp");

        if (duty === "DP") {
          jQuery("body").addClass("current-duty-dp");
        }
        if (duty === "IB") {
          jQuery("body").addClass("current-duty-ib");
        }
      }

      document.dispatchEvent(
        new CustomEvent("jb_duty_changed", { detail: duty })
      );
    },
  },
  mounted() {
    this.loading = true;
    return jbs_api
      .get("WishList")
      .then((response) => {
        this.items = response.data;
        for (var i in this.items) {
          this.items[i]._source._add_qty = 1;
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>